<template>
    <div class="coreDriverBox">
        <!-- <div class="chainTitle">核心产品</div> -->
        <div v-if="coreProduct.length>0"  :class="!isClickFlag?'box':'box showRight'">
            <div id="mainProduct" class="main" style="width: 100%;height:100%;"></div>
            <div class="boxRight" v-if="isClickFlag">
                <div class="lineBotton">
                    <div id="mainProductLine" class="main" style="width: 100%;height:100%;"></div>
                </div>
            </div>
        </div>
        <DataEmpty v-if="coreProduct.length==0&&isEnd"></DataEmpty>
        <el-dialog title="产品数据详情" :visible.sync="dialogTableVisible" center>
          <el-table :data="gridData">
            <el-table-column type="index" label="id" ></el-table-column>
            <el-table-column property="productName" label="产品名称"></el-table-column>
            <el-table-column property="specification" label="规格"></el-table-column>
            <el-table-column property="quantity" label="签发量"></el-table-column>
            <el-table-column property="inspectionNumber" label="受检编号"></el-table-column>
            <el-table-column property="issueDate" label="签发日期"></el-table-column>
            <el-table-column property="issueAgency" label="批签发机构"></el-table-column>
          </el-table>
        </el-dialog>

    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import DataEmpty from '../dataEmpty.vue'
    import ssUtil from '@/utils/SStorage'
    import baseUrl from '@/utils/setting'
  export default {
    name: 'coreProduct',
    data() {
        return {
            coreProduct: {},
            isClickFlag : false,
            paramsInfo:{},
            onceFlag:'',
            isEnd:false,
            dialogTableVisible:false,
            gridData:[]
        }
    },
    computed: {...mapState(['indexSearchInfo','productRouterInfo','productShowInfo','colorArr'])},
    components:{ DataEmpty },
    created(){
        this.paramsInfo = this.productRouterInfo
        this.getCompanyCoreProduct(this.productRouterInfo);
    },
    methods: {
        //获取核心产品
        getCompanyCoreProduct( params ){
            this.isEnd = false
            this.$store.dispatch('getCompanyCoreProduct',{coCode:params.coCode}).then( res => {
                this.isEnd = true
                if( res.status == 200 ){
                    this.coreProduct = res.data.data
                    if(this.coreProduct.length>0){
                       this.showGraph(50,800);
                    }
                }
            })
        },
        //获取折线图数据
        getLineInfo(params){
            if( !params.data.productCode ){
                return;
            }
            const that = this
            this.$store.dispatch('getCompanyCoreProductSeriesData',{coCode:params.data.code,productCode:params.data.productCode}).then( res => {
                if( res.data.retCode == '000'){
                    this.showLine(res.data.data);
                }
            }).catch(error => {
              console.log(error)
              this.$store.dispatch('getCompanyCoreProductIssueData',{coCode:params.data.code,productCode:params.data.productCode}).then( res => {
                  that.dialogTableVisible = true
                  that.gridData = res.data.data
              }).catch(error => {console.log(error)})
            })
        },
        //展示关系图
        showGraph(num1,num2){
            let that = this,elList=[],myChart = [],data = [],links = [];
            let color = ['#989898', '#925559', '#d16c5d', '#ba774a', '#55787f', '#787d60', '#ca9f51', '#6f8765', '#4d8d7a', '#667c92', '#996b6b', '#a08db4', '#bcbcbb', '#b1b594', '#a49f95', '#ac7a79', '#bebeab', '#99a590', '#9cabbd', '#748596', '#87919e', '#706777', '#82778d', '#baac92', '#919382']
            data.push({
                    value : that.paramsInfo.name,
                    name : that.paramsInfo.name,
                    symbolSize : 50,
                    draggable: true,
                    code : that.paramsInfo.coCode,
                    itemStyle: {
                        normal: {
                            color: that.colorArr[0]
                        }
                    }
            })
            this.coreProduct.forEach(function( item,index ){
                data.push({
                    value : item.productName,
                    name : item.productName,
                    symbolSize : item.productSort <= 4 ? 20 + (4-item.productSort) * 10 : 20,
                    code : that.productRouterInfo.coCode,
                    productCode : item.productCode,
                    industry : item.industry,
                    remark : item.remark,
                    itemStyle: {
                        normal: {
                            // color: that.colorArr[item.productSort]
                            color: color[index]
                        }
                    }
                })
                links.push({
                        source:  that.paramsInfo.name,
                        target:  item.productName
                })
            })
            var option = {
                title: {text: ''},
                tooltip: {
                        show: true,
                        trigger: 'item'
                },
                animation:false,
                animationEasingUpdate: 'quinticInOut',
                series: [
                {
                    type: 'graph',
                    layout: 'force',
                    symbol: 'circle',
                    symbolSize: num1,
                    draggable: true,
                    roam: true,
                    label: {
                        normal: {
                            show: true,
                            fontWeight: 500,
                            fontSize: 16,
                            position:'top',
                            color:'#333',
                        }
                    },
                    force: {                // 力引导布局相关的配置项，力引导布局是模拟弹簧电荷模型在每两个节点之间添加一个斥力，每条边的两个节点之间添加一个引力，每次迭代节点会在各个斥力和引力的作用下移动位置，多次迭代后节点会静止在一个受力平衡的位置，达到整个模型的能量最小化。
                        repulsion: num2,            // [ default: 50 ]节点之间的斥力因子(关系对象之间的距离)。支持设置成数组表达斥力的范围，此时不同大小的值会线性映射到不同的斥力。值越大则斥力越大
                        edgeLength:155      // [ default: 30 ]边的两个节点之间的距离(关系对象连接线两端对象的距离,会根据关系对象值得大小来判断距离的大小)，
                    },
                    edgeSymbol: ['circle', 'arrow'],
                    edgeSymbolSize: [4, 10],
                    data: data,
                    tooltip: {
                        // formatter: '{b}',
                        formatter: function(params){//触发之后返回的参数，这个函数是关键
                            // console.log(params);
                            if ( params.data.productCode  ) {//如果触发节点
                                return  params.data.remark;//返回标签
                            }else {
                                return  params.data.name;
                            }
                            // if (params.data.category !=undefined) {//如果触发节点
                            // return params.data.remark;//返回标签
                            // }
                        },
                        backgroundColor: 'rgba(50,50,50,0.8)'
                    },
                    links: links,
                    lineStyle: {
                        normal: {
                            opacity: 0.5,
                            width: 1,
                            curveness: 0
                        }
                    }
                }
                ]
            };
            // 基于准备好的dom，初始化echarts实例
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('mainProduct'))
                myChart.setOption(option);
                myChart.on('click', function (param) {
                    if(param.data.source&&param.data.target){
                        return;
                    }
                    if( param.data.name == that.productShowInfo.name){
                        that.isClickFlag = false;
                        that.onceFlag = param.data.name;
                        return;
                    }else{
                        if( that.onceFlag == ''){
                            that.isClickFlag = true;
                            that.onceFlag = param.data.name;
                            that.getLineInfo(param)
                        }else if( that.onceFlag == param.data.name ){
                            that.onceFlag = param.data.name;
                            let params = {
                                type: 'product',
                                name:param.data.name,
                                industry:param.data.industry,
                                productCode:param.data.productCode
                            }
                            that.$store.dispatch('productRouterInfo',params)
                        }else{
                            that.isClickFlag = true;
                             that.onceFlag = param.data.name;
                              that.getLineInfo(param)
                        }
                    }
                });
            })
        },
        //展示折线图
        showLine(params){
            let that = this,elList=[],myChart = [], xData = [],seriesData = [],maxMinVal={};
            let list = params.list
            maxMinVal.min = params.minValue;
            maxMinVal.max = params.maxValue;
            list.forEach(function( it ){
                xData.push(it.dataTime.split(' ')[0]),
                seriesData.push(it.dataValue)
            })
            let seriesCode = list[0].seriesCode
            var option = {
                    title: {
                        left: 'center',
                        text: list[0].seriesName,
                        subtext: '下载数据',
                        sublink: baseUrl+'/user/downLoadSeriesData?seriesCode='+seriesCode+'&Authorization='+sessionStorage.getItem('authToken'),
                        subtarget:"blank",
                        subtextStyle:{//副标题内容的样式
                          color: '#d16c5d',
                          fontStyle:'normal',//主标题文字字体风格，默认normal，有italic(斜体),oblique(斜体)
                          fontWeight:"bold",//可选normal(正常)，bold(加粗)，bolder(加粗)，lighter(变细)，100|200|300|400|500...
                          fontFamily:"san-serif",//主题文字字体，默认微软雅黑
                          fontSize:12//主题文字字体大小，默认为12px
                        },
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: function (list) {
                            list = list[0];
                            return list.value+'<br />'+list.name;
                        },
                        axisPointer: {
                            animation: false
                        }
                    },
                    grid : {
                        containLabel:true
                    },
                    xAxis: {
                        type: 'category',
                        data: xData,
                        splitNumber:5,
                        axisLabel:{
                            rotate:30,
                        }
                    },
                    yAxis: {
                        type: 'value',
                        min: parseInt(maxMinVal.min<0?maxMinVal.min*1.2:maxMinVal.min*0.8),
                        max: parseInt(maxMinVal.max<0?maxMinVal.max*0.8:maxMinVal.max*1.2),
                        splitNumber:8
                    },
                    series: [{
                        name:list[0].seriesName,
                        type:'line',
                        data:seriesData
                    }]
                };
            this.$nextTick(function(){
                myChart = that.$echarts.init( document.getElementById('mainProductLine'))
                myChart.setOption(option);
                // myChart.on('click', function (param) {
                //     that.isClickFlag = true;
                //     that.getProductSeries(param.data);
                // });
            })
        }
    },
    mounted() {},
    watch:{
        productRouterInfo:{
            handler(newVla, oldVal) {
                if( this.paramsInfo.name != this.productRouterInfo.name){
                    let coCode = this.productRouterInfo.coCode
                    this.paramsInfo = this.productRouterInfo
                    this.getCompanyCoreProduct(this.productRouterInfo)
                }
            },
            deep: true
        }
    }
  }
</script>

<style lang="scss" src="../../../sass/productInfo/coreDriver.scss"></style>



// WEBPACK FOOTER //
// src/components/productInfoComponents/companyCom/coreProduct.vue